// extracted by mini-css-extract-plugin
export default {"overlay":"BC-z","bodyOpen":"CC-z","content":"DC-z","header":"EC-z","closeNoHeading":"FC-z"};